"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var window_container_api_1 = require("./window-container-api");
var base_window_container_api_1 = require("./base-window-container-api");
var OpenFinApi = /** @class */ (function (_super) {
    __extends(OpenFinApi, _super);
    function OpenFinApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(OpenFinApi.prototype, "type", {
        get: function () {
            return window_container_api_1.WindowContainerApiType.OpenFin;
        },
        enumerable: true,
        configurable: true
    });
    OpenFinApi.prototype.getFin = function () {
        return new Promise(function (resolve) { return fin.desktop.main(resolve); }).then(function () { return fin; });
    };
    Object.defineProperty(OpenFinApi.prototype, "currentWindowName", {
        get: function () {
            return fin.desktop.Window.getCurrent().name;
        },
        enumerable: true,
        configurable: true
    });
    OpenFinApi.prototype.subscribe = function (senderUuid, topic, listener) {
        return this.getFin().then(function (fin) {
            return new Promise(function (resolve, reject) {
                return fin.desktop.InterApplicationBus.subscribe(senderUuid, topic, listener, resolve, reject);
            });
        });
    };
    return OpenFinApi;
}(base_window_container_api_1.BaseWindowContainerApi));
exports.OpenFinApi = OpenFinApi;
exports.openFinApi = new OpenFinApi();



//////////////////
// WEBPACK FOOTER
// /app/~/redi-window-container-web-lib/dist/business/openfin-api.js
// module id = 43
// module chunks = 0